(function (restored, undefined) {


    let mc_submit_callback = new WeakMap();



    function generate_callback_name() {
        return "cb_" + Math.floor((Math.random() * 65535 * 65535) + (Math.random() * 65535)).toString(16);
    }


    function get_ajax_submit_url(form, callback_name) {
        var url = form.getAttribute("action");
        url = url.replace("/post?u=", "/post-json?u=");
        if (callback_name)
            url += "&c=restored." + callback_name + "&";
        else
            url += "&c=&";

        const params = new URLSearchParams(new FormData(form));
        url += params;
        return url;
    };


    function validate_email(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };


    function show_error_message(form, message) {
        var error_element = form.querySelector(".mc_form_error");
        
        if (!error_element) return;
        var error_text = form.querySelector(".mc_form_error > span");
        
        
        if (message) {
            error_text.innerHTML = message;
            error_element.style.display = "inline";
        } else {
            error_text.innerHTML = "";
            error_element.style.display = "none";

        }
            
    }

    restored.mc_set_form_callback = function (form_id, callback) {
        let form = document.getElementById(form_id);
        if (!form) return;
        mc_submit_callback[form] = callback;
    }


    embedded_mc_callback = function (form, resp, callback_name) {

        function set_display(selector, display) {
            var element = form.querySelector(selector);
            if (element) element.style.display = display;
        }

        var success = false;

        delete restored[callback_name];

        // On successful form submission, display a success message and reset the form
        if (resp.result == "success") {

            form.reset();

            set_display(".mc-signup", "none");
            set_display(".mc-thanks", "block");

            success = true;

        } else {
            // If the form has errors, display them, inline if possible, or appended to #mce-error-response
            if (resp.msg === "captcha") {
                var url = form.getAttribute("action");
                var parameters = $.param(resp.params);
                url = url.split("?")[0];
                url += "?";
                url += parameters;
                window.open(url);
            };

            show_error_message(form, resp.msg);

        }

        if (mc_submit_callback[form]) {
            mc_submit_callback[form](success);
        }

    }


    init_mailchimp_form = function (form) {

        function ajax_submit(event) {

            event.preventDefault();

            var data = this;
            const form_data = new FormData(form);

            // Validate email before submitting
            if (!validate_email(form_data.get("EMAIL"))) {
                show_error_message(form, "Please enter a valid email address");
                return;
            }
            show_error_message(form)

            // Store global reference to callback function
            var callback_name = generate_callback_name();
            restored[callback_name] = function (resp) {
                embedded_mc_callback(form, resp, callback_name);
            }

            const url = get_ajax_submit_url(form, callback_name);

            // Use script-loading hack to as mailchimp does not provide CORS headers
            var head = document.head || document.documentElement;

            var script = document.createElement("script");
            script.async = true;
            script.src = url;

            // console.log(callback_name);
            // return;

            script.onload = script.onreadystatechange = function () {

                if (!script.readyState || /loaded|complete/.test(script.readyState)) {

                    if (script.parentNode) {
                        script.parentNode.removeChild(script);
                    }

                    script = null;
                }
            };

            head.insertBefore(script, head.firstChild);

        }

        form.addEventListener("submit", ajax_submit);

    }


    restored.mailchimp_init = function () {

        document.addEventListener("DOMContentLoaded", function (event) {
            document.querySelectorAll("form.embedded-mc-signup").forEach(form => init_mailchimp_form(form));
        });

    };

}(window.restored = window.restored || {}));

restored.mailchimp_init();

